import { IUser } from "../../user/IUser";
import { isDDProMemberPays, isPremium } from "../../utils";
import { IMenuItem } from "../IMenu";

export const freeTrial: IMenuItem = {
  label: "Free trial",
  href: "/new-member"
};

export const becomeMemberPayment: IMenuItem = {
  label: "Free trial",
  href: "/become-member/payment"
};

export const login: IMenuItem = {
  label: "Log in",
  href: "/login"
};

export const logout: IMenuItem = {
  label: "Log out"
};

export const shoppingList: IMenuItem = {
  label: "Shopping List",
  href: "/shopping-list"
};

export const tracking: IMenuItem = {
  label: "My tracking",
  href: "/tracking"
};

export const appCta: IMenuItem = {
  label: "Download the Diet Doctor app"
};

export const stores: IMenuItem[] = [
  {
    label: "App Store",
    href: "https://apps.apple.com/us/app/diet-doctor-eat/id1440002708"
  },
  {
    label: "Play Store",
    href: "https://play.google.com/store/apps/details?id=com.dietdoctor.EatApp"
  }
];

export const myAccount: IMenuItem = {
  label: "My account",
  children: [
    {
      label: "My personal settings",
      href: "/user/settings"
    },
    {
      label: "My food preferences",
      href: "/user/food-preferences"
    },
    {
      label: "My favorites",
      href: "/member/favorites",
      onlyPremium: true
    },
    {
      label: "My meal plans",
      href: "/low-carb/meal-plans/my-meal-planner",
      onlyPremium: true
    },
    {
      label: "My shopping list",
      href: "/shopping-list",
      onlyPremium: true
    },
    {
      label: "My tracking",
      href: "/tracking",
      onlyPremium: true
    },
    {
      label: "My membership",
      href: "/my-account"
    },
    {
      label: "My communication preferences",
      href: "/braze/preference-center",
    },
    {
      label: "My benefits",
      href: "/explore-dd-plus"
    },
    {
      label: "Contact us",
      href: "https://dietdoctor.zendesk.com/hc/en-us"
    }
  ]
};

export const ddPro: IMenuItem = {
  children: [
    {
      label: "DD PRO",
      children: [
        {
          label: "Add member",
          href: "/pro/add"
        },
        {
          label: "View members",
          href: "/pro"
        },
        {
          label: "QR code in PDF",
          href: "/pro/qr",
          guard: (user: IUser) => isDDProMemberPays(user),
          target: "_blank"
        },
        {
          label: "Document Hub",
          href: "/ddpro/resources"
        },
        {
          label: "Low carb & keto for clinicians",
          href: "/low-carb/for-doctors"
        },
        {
          label: "CME course",
          href: "/cme"
        },
        {
          label: "About DD Pro",
          href: "/pro/about"
        }
      ]
    }
  ]
};

export const all: IMenuItem[] = [
  { ...ddPro },
  {
    label: "Menu",
    children: [
      {
        label: "Guides",
        children: [
          {
            label: "Low carb",
            children: [
              {
                label: "Low carb for beginners",
                href: "/low-carb"
              },
              {
                label: "All guides",
                href: "/low-carb/guides"
              },

              {
                label: "Foods",
                href: "/low-carb/foods"
              },
              {
                label: "Visual guides",
                href: "/low-carb/visual-guides"
              },
              {
                label: "Side effects",
                href: "/low-carb/side-effects"
              },
              {
                label: "Meal plans",
                href: "/low-carb/diet-meal-plan"
              }
            ]
          },
          {
            label: "Keto",
            children: [
              {
                label: "Keto for beginners",
                href: "/low-carb/keto"
              },
              {
                label: "All guides",
                href: "/low-carb/keto/guides"
              },
              {
                label: "Foods",
                href: "/low-carb/keto/foods"
              },
              {
                label: "Visual guides",
                href: "/low-carb/keto/visual-guides"
              },
              {
                label: "Side effects",
                href: "/low-carb/side-effects"
              },
              {
                label: "Meal plans",
                href: "/low-carb/keto/diet-plan"
              }
            ]
          },
          {
            label: "High protein",
            children: [
              {
                label: "What are high protein diets?",
                href: "/high-protein"
              },
              {
                label: "Foods",
                href: "/high-protein/foods"
              },
              {
                label: "Snacks",
                href: "/high-protein/snacks"
              },
              {
                label: "Meal plans",
                href: "/high-protein/diet-plan"
              }
            ]
          },
          {
            label: "Higher-satiety eating",
            children: [
              {
                label: "Higher-satiety eating",
                href: "/satiety"
              },
              {
                label: "High-satiety foods",
                href: "/satiety/foods"
              },
              {
                label: "Satiety per calorie",
                href: "/satiety/science"
              },
              {
                label: "Satiety score",
                href: "/satiety/score"
              },
              {
                label: "Meal plans",
                href: "/satiety/meal-plan"
              }
            ]
          },
          {
            label: "Food Navigator",
            href: "/food-navigator"
          },
          {
            label: "Intermittent fasting",
            href: "/intermittent-fasting"
          },
          {
            label: "Low carb and keto FAQ",
            href: "/low-carb/questions-and-answers"
          },
          {
            label: "The Diet Doctor food policy",
            href: "/food-policy"
          }
        ]
      },
      {
        label: "Weight loss",
        children: [
          {
            label: "Healthy weight loss",
            href: "/weight-loss"
          },
          {
            label: "How to lose weight",
            href: "/weight-loss/how-to-lose-weight"
          },
          {
            label: "Low carb weight loss",
            href: "/low-carb/benefits/how-to-lose-weight-with-low-carb"
          },
          {
            label: "Weight loss program",
            href: "/weight-loss/10-weeks",
            onlyPremium: true
          },
          {
            label: "Weight loss resources",
            href: "/weight-loss/resources"
          }
        ]
      },
      {
        label: "Meal plans",
        children: [
          {
            label: "My meal plans",
            href: "/low-carb/meal-plans/my-meal-planner",
            onlyPremium: true,
            disabled: (user: IUser) => !isPremium(user)
          },
          {
            label: "Personalized meal plans",
            href: "/low-carb/meal-plans/personalized-meal-plans",
            onlyPremium: true
          },
          {
            label: "All meal plans",
            href: "/low-carb/meal-plans/all"
          },
          {
            guard: (user: IUser) => isPremium(user),
            label: "High protein meal plans",
            children: [
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "High protein",
                href: "/high-protein/meal-plans"
              }
            ]
          },
          {
            guard: (user: IUser) => isPremium(user),
            label: "Low carb meal plans",
            children: [
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "All low carb meal plans",
                href: "/low-carb/diet-meal-plan"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Intermittent fasting",
                href: "/low-carb/meal-plans/intermittent-fasting-meal-plan"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Quick and easy",
                href: "/low-carb/meal-plans/quick-and-easy"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Budget",
                href: "/low-carb/meal-plans/budget"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Family friendly",
                href: "/low-carb/meal-plans/family-friendly"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Dairy-free",
                href: "/low-carb/meal-plans/dairy-free"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Vegetarian",
                href: "/low-carb/meal-plans/vegetarian"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "World cuisine",
                href: "/low-carb/meal-plans/world-cuisine"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "DD favorites",
                href: "/low-carb/meal-plans/team-dd-favorites"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Authors",
                href: "/low-carb/meal-plans/recipe-creators"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Other",
                href: "/low-carb/meal-plans/other"
              }
            ]
          },
          {
            guard: (user: IUser) => isPremium(user),
            label: "Keto meal plans",
            children: [
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "All keto meal plans",
                href: "/low-carb/keto/diet-plan"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Quick and easy",
                href: "/low-carb/keto/meal-plans/quick-and-easy"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Budget",
                href: "/low-carb/keto/meal-plans/budget"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Family-friendly",
                href: "/low-carb/keto/meal-plans/family-friendly"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Dairy-free",
                href: "/low-carb/keto/meal-plans/dairy-free"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Vegetarian",
                href: "/low-carb/keto/meal-plans/vegetarian"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "World cuisine",
                href: "/low-carb/keto/meal-plans/world-cuisine"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "DD favorites",
                href: "/low-carb/keto/meal-plans/team-dd-favorites"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Authors",
                href: "/low-carb/keto/meal-plans/recipe-creators"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Other",
                href: "/low-carb/keto/meal-plans/other"
              }
            ]
          },
          {
            label: "High-protein meal plans",
            href: "/high-protein/diet-plan",
            guard: (user: IUser) => !isPremium(user)
          },
          {
            label: "Higher-satiety meal plans",
            href: "/satiety/meal-plan"
          },
          {
            label: "Keto meal plans",
            href: "/low-carb/keto/diet-plan",
            guard: (user: IUser) => !isPremium(user)
          },
          {
            label: "Low carb meal plans",
            href: "/low-carb/diet-meal-plan",
            guard: (user: IUser) => !isPremium(user),
            children: [
              {
                label: "All low carb meal plans",
                href: "/low-carb/diet-meal-plan",
                guard: (user: IUser) => !isPremium(user)
              },
              {
                label: "Intermittent fasting",
                href: "/low-carb/meal-plans/intermittent-fasting-meal-plan",
                guard: (user: IUser) => !isPremium(user)
              },
              {
                label: "Budget",
                href: "/low-carb/meal-plans/cheap-diet-meal-plan",
                guard: (user: IUser) => !isPremium(user)
              },
              {
                label: "Family-friendly",
                href: "/low-carb/meal-plans/family-diet-meal-plan",
                guard: (user: IUser) => !isPremium(user)
              },
              {
                label: "Vegetarian",
                href: "/low-carb/meal-plans/vegetarian-diet-meal-plan",
                guard: (user: IUser) => !isPremium(user)
              }
            ]
          }
        ]
      },
      {
        label: "Recipes",
        children: [
          {
            label: "My favorite recipes",
            href: "/member/favorites",
            onlyPremium: true
          },
          {
            label: "Low carb recipes",
            children: [
              {
                label: "All recipes",
                href: "/low-carb/recipes"
              },
              {
                label: "Meals",
                href: "/low-carb/recipes/meals"
              },
              {
                label: "Breakfast",
                href: "/low-carb/recipes/breakfasts"
              },
              {
                label: "Bread",
                href: "/low-carb/recipes/bread"
              },
              {
                label: "Desserts",
                href: "/low-carb/recipes/desserts"
              },
              {
                label: "Snacks",
                href: "/low-carb/recipes/snacks-2"
              },
              {
                label: "Condiments",
                href: "/low-carb/keto/recipes/sauces-dressings"
              },
              {
                label: "Side dishes",
                href: "/low-carb/recipes/side-dishes-2"
              },
              {
                label: "Drinks",
                href: "/low-carb/recipes/drinks"
              }
            ]
          },
          {
            label: "Keto recipes",
            children: [
              {
                label: "All recipes",
                href: "/low-carb/keto/recipes"
              },
              {
                label: "Meals",
                href: "/low-carb/keto/recipes/meals"
              },
              {
                label: "Breakfast",
                href: "/low-carb/keto/recipes/breakfasts"
              },
              {
                label: "Bread",
                href: "/low-carb/keto/recipes/bread"
              },
              {
                label: "Desserts",
                href: "/low-carb/keto/recipes/desserts"
              },
              {
                label: "Snacks",
                href: "/low-carb/keto/recipes/snacks"
              },
              {
                label: "Condiments",
                href: "/low-carb/keto/recipes/sauces-dressings"
              },
              {
                label: "Side dishes",
                href: "/low-carb/recipes/side-dishes-2"
              },
              {
                label: "Drinks",
                href: "/low-carb/recipes/drinks"
              }
            ]
          },
          {
            label: "High protein recipes",
            href: "/high-protein/recipes"
          },
          {
            label: "Higher-satiety recipes",
            href: "/satiety/recipes"
          },
          {
            label: "Recipe collections",
            href: "/low-carb/recipes/collections"
          },
          {
            label: "Cooking videos",
            href: "/video/cooking"
          },
          {
            label: "Recipes FAQ",
            href: "/low-carb/recipes/faq"
          }
        ]
      },
      {
        label: "Health",
        children: [
          {
            label: "Health benefits",
            href: "/health"
          },
          {
            label: "Reverse type 2 diabetes",
            href: "/diabetes"
          },
          {
            label: "Normalize blood pressure",
            href: "/blood-pressure"
          },
          {
            label: "Nutrition",
            href: "/nutrition"
          }
        ]
      },
      {
        label: "Videos",
        children: [
          {
            label: "Videos",
            href: "/video"
          },
          {
            label: "Courses",
            href: "/video/courses"
          },
          {
            label: "Movies",
            href: "/video/movies"
          },
          {
            label: "Podcast",
            href: "/video/podcast"
          }
        ]
      }
    ]
  },
  {
    children: [
      {
        ...freeTrial
      },
      {
        ...login
      }
    ]
  },
  {
    children: [
      {
        label: "News",
        href: "/news"
      },
      {
        label: "Programs & support",
        children: [
          {
            label: "The Diabetes Program",
            href: "/diabetes-program",
            onlyPremium: true
          },
          {
            label: "New Me 2-Week Reset",
            href: "/newme",
            onlyPremium: true
          },
          {
            label: "Get Started Challenge",
            href: "/low-carb/get-started"
          },
          {
            label: "Weight Loss For Good",
            href: "/weight-loss/10-weeks",
            onlyPremium: true
          },
          {
            label: "Higher satiety program",
            href: "/satiety/3-weeks/program",
            onlyPremium: true
          },
          {
            label: "Keto with Kristie",
            href: "/low-carb/keto/5-weeks",
            onlyPremium: true
          },
          {
            label: "For clinicians",
            href: "/low-carb/for-doctors"
          },
          {
            label: "CME course",
            href: "/free-continuing-medical-education-course-on-low-carb"
          },
          {
            label: "Find a doctor",
            href: "/low-carb/doctors"
          },
          {
            label: "Help center",
            href: "https://dietdoctor.zendesk.com/hc/en-us"
          }
        ]
      },
      {
        label: "Success stories",
        href: "/low-carb/success-stories"
      },
      {
        label: "About us",
        children: [
          {
            label: "About Diet Doctor",
            href: "/about"
          },
          {
            label: "Contact us",
            href: "https://dietdoctor.zendesk.com/hc/en-us/requests/new"
          },
          {
            label: "Team",
            href: "/about/team-diet-doctor"
          },
          {
            label: "Membership",
            href: "/member/about-membership"
          },
          {
            label: "Our story",
            href: "/about/the-story-of-diet-doctor"
          }
        ]
      },
      {
        label: "Contact us",
        href: "https://dietdoctor.zendesk.com/hc/en-us/requests/new"
      },
      {
        label: "Help center",
        href: "https://dietdoctor.zendesk.com/hc/en-us"
      }
    ]
  }
];
